<template>
  <b-row @click="$emit('select')" :class="className">
    <b-col :cols="cols" class="text-truncate" :title="place">{{ place }}</b-col>
    <b-col v-if="count" class="text-right align-middle">{{ count }}</b-col>
  </b-row>
</template>

<script>
export default {
  name: 'RequestedCity',
  props: {
    placeId: {
      type: String,
      required: true,
    },
    place: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: false,
      default: 1,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    className() {
      return `no-pad ${this.selected ? 'selected' : ''}`;
    },
    cols() {
      return this.count ? 9 : 12;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/css/variables';

  .row {
    padding: 23px 0;
    border-bottom: 1px solid #282828;
    cursor: pointer;
    color: #787878;

    &.selected {
      color: $yellow;
    }
  }
</style>
